import React from 'react';
import './About.css';
import { Code, GraduationCap, Briefcase, Languages, Phone, Mail, Linkedin, Github, MapPin } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="section-title">
            About <span className="gradient-text">Me</span>
          </h2>
          <p className="section-description">
            Software Engineering student passionate about building innovative digital solutions
          </p>
        </div>

        <div className="about-content">
          <div className="about-main">
            <div className="about-intro">
              <h3 className="about-name">Nael Aburomii</h3>
              <p className="about-title">Software Engineering Student | Junior Software Engineer</p>
              
              <div className="about-contact-info">
                <div className="contact-item">
                  <MapPin size={18} />
                  <span>Israel</span>
                </div>
                <div className="contact-item">
                  <Phone size={18} />
                  <a href="tel:+972523899868">052-389-9868</a>
                </div>
                <div className="contact-item">
                  <Mail size={18} />
                  <a href="mailto:naelamen@gmail.com">naelamen@gmail.com</a>
                </div>
                <div className="contact-item">
                  <Linkedin size={18} />
                  <a href="https://www.linkedin.com/in/nael-abu-romii-a4a0a8229" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                </div>
                <div className="contact-item">
                  <Github size={18} />
                  <a href="https://github.com/naelaburomii" target="_blank" rel="noopener noreferrer">GitHub</a>
                </div>
              </div>

              <p className="about-summary">
                Software Engineering student with hands-on experience in full-stack development, 
                mobile applications, and quality assurance. Strong background in building, testing, 
                and improving real-world applications using modern technologies. Detail-oriented with 
                QA experience and a strong foundation in software engineering principles.
              </p>
            </div>

            <div className="about-details">
              <div className="about-card">
                <div className="about-card-icon">
                  <GraduationCap size={24} />
                </div>
                <div className="about-card-content">
                  <h4 className="about-card-title">Education</h4>
                  <p className="about-card-text">
                    <strong>B.Sc. in Software Engineering</strong><br />
                    Sami Shamoon College of Engineering (SCE)<br />
                    <span className="about-card-meta">2021 – Present | Expected Graduation: 2025 | GPA: 80</span>
                  </p>
                  <div className="about-card-highlights">
                    <span className="highlight-tag">Testing & Quality (95)</span>
                    <span className="highlight-tag">C Programming (91)</span>
                    <span className="highlight-tag">Advanced OOP – Java (88)</span>
                  </div>
                </div>
              </div>

              <div className="about-card">
                <div className="about-card-icon">
                  <Briefcase size={24} />
                </div>
                <div className="about-card-content">
                  <h4 className="about-card-title">Experience</h4>
                  <p className="about-card-text">
                    <strong>Customer Service & QA Engineer</strong><br />
                    Click Delivery App<br />
                    <span className="about-card-meta">2019 – 2022</span>
                  </p>
                  <p className="about-card-description">
                    Performed functional, regression, and usability testing; reported bugs and 
                    collaborated with developers to improve product quality and user experience.
                  </p>
                </div>
              </div>

              <div className="about-card">
                <div className="about-card-icon">
                  <Code size={24} />
                </div>
                <div className="about-card-content">
                  <h4 className="about-card-title">Technical Skills</h4>
                  <div className="skills-grid">
                    <div className="skill-category">
                      <strong>Languages:</strong>
                      <div className="skill-tags">
                        <span className="skill-tag">C</span>
                        <span className="skill-tag">C++</span>
                        <span className="skill-tag">C#</span>
                        <span className="skill-tag">Java</span>
                        <span className="skill-tag">Python</span>
                        <span className="skill-tag">JavaScript</span>
                        <span className="skill-tag">HTML</span>
                      </div>
                    </div>
                    <div className="skill-category">
                      <strong>Frameworks & Technologies:</strong>
                      <div className="skill-tags">
                        <span className="skill-tag">React</span>
                        <span className="skill-tag">Flutter</span>
                        <span className="skill-tag">Firebase</span>
                        <span className="skill-tag">MongoDB</span>
                        <span className="skill-tag">SQL</span>
                      </div>
                    </div>
                    <div className="skill-category">
                      <strong>DevOps & Tools:</strong>
                      <div className="skill-tags">
                        <span className="skill-tag">Git</span>
                        <span className="skill-tag">GitHub</span>
                        <span className="skill-tag">Jenkins</span>
                        <span className="skill-tag">Docker</span>
                        <span className="skill-tag">Jira</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="about-card">
                <div className="about-card-icon">
                  <Languages size={24} />
                </div>
                <div className="about-card-content">
                  <h4 className="about-card-title">Languages</h4>
                  <div className="languages-list">
                    <div className="language-item">
                      <span className="language-name">Arabic</span>
                      <span className="language-level">Native</span>
                    </div>
                    <div className="language-item">
                      <span className="language-name">Hebrew</span>
                      <span className="language-level">Fluent</span>
                    </div>
                    <div className="language-item">
                      <span className="language-name">English</span>
                      <span className="language-level">Fluent</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

